import { render, staticRenderFns } from "./MhSpinner.vue?vue&type=template&id=47b354ea&"
import script from "./MhSpinner.vue?vue&type=script&lang=js&"
export * from "./MhSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../GbR/10__Projekte/2020-05-28__ROTORBOOKS/03  Website/wordpress/wp-content/themes/wp-kickstart-v3-theme/vue-cli-dev/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports